module.exports = __webpack_public_path__ + "static/media/action-icon-active.990b266a.svg";